export default "__VITE_ASSET__ce0130e5__"